import { render, staticRenderFns } from "./Operador.vue?vue&type=template&id=988b58fe&scoped=true&"
import script from "./Operador.vue?vue&type=script&lang=js&"
export * from "./Operador.vue?vue&type=script&lang=js&"
import style0 from "./Operador.vue?vue&type=style&index=0&id=988b58fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b58fe",
  null
  
)

export default component.exports